@if (!productsPromoService.hasAnyTellentHrFeature()) {
  <div class="banner-wrapper">
    <div class="banner-content">
      <div class="text-wrap">
        <div class="heading">
          {{ 'app.promote.tellent_hr.hired_candidate_banner.heading' | translate }}
        </div>
        <div class="subheading">
          {{ 'app.promote.tellent_hr.hired_candidate_banner.subheading' | translate }}
        </div>
        <div layout>
          <rt-button
            (click)="productsPromoService.bookDemo('congratsOnHire')"
            variant="secondary"
            >{{ 'app.promote.tellent_hr.hired_candidate_banner.demo' | translate }}</rt-button
          >
        </div>
      </div>
      <div class="logo"><img src="assets/images/hired_candidate_hr_promo.png" width="136" /></div>
    </div>
  </div>
}
